<div class="card">
  <div class="row">
    <div class="col-12 text-center">
      <h1>Research Portal Disclaimer</h1>
    </div>
    <div class="col-2 text-end">
      <button class="btn-link" (click)="close()">&times;</button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <p>
        Access to the CAL Research Portal is strictly restricted to authorized registered recipients (Recipients). The Recipient's login
        details and/or the contents of the Portal shall not be disclosed to unauthorized persons by Recipient. The reports and other content
        in the Portal has been prepared and released on the basis of publicly available information, internally developed data and other
        sources, believed to be reliable. Capital Alliance Securities (Private) Limited however does not warrant its completeness or
        accuracy. Opinions and estimates given constitute a judgment as of the date of the material and are subject to change without
        notice. This report is not intended as an offer or solicitation for the purchase or sale of any financial instrument. The Recipients
        must make their own independent decision regarding any securities, investments or financial instruments mentioned herein. Securities
        or financial instruments mentioned may not be suitable to all investors. Capital Alliance Securities (Private) Limited it's
        directors, officers, consultants, employees, outsourced research providers associates or business partner, will not be responsible,
        for any claims damages, compensation, suits, damages, loss, costs, charges, expenses, outgoing or payments including attorney's fees
        which Recipients suffer or incur directly or indirectly arising out of actions taken as a result of review of the contents of the
        Portal. The reports and other content are strictly for information purposes of Recipient. Unauthorized access, disclosure, copying
        or distribution of the contents herein is prohibited and may be a criminal offence.
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col text-end">
      <button type="submit" class="btn btn-fill" (click)="accept()">Accept</button>
      <button type="submit" class="btn btn-fill" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
